import React from "react";
// import { motion } from "framer-motion";
import NoSSRMotion from "components/NoSSRMotion";

export default function FadeInOut(props) {
	const { myKey, children, animate, initial, withHeight = true, className = "" } = props;

	const variants = {
		visible: {
			scaleY: 1,
			transform: "translateZ(0)", // Hardware acceleration
			...(withHeight && {
				height: "auto",
				// y: 0, // Translate the element by 50% of its height
			}),
			opacity: 1,
			// overflow: "visible",
			transition: {
				opacity: { duration: 0.15 },
				height: { duration: 0.15 },
				scaleY: { duration: 0.15 },
			},
		},
		hidden: {
			scaleY: 0,
			transform: "translateZ(0)", // Hardware acceleration
			...(withHeight && {
				height: 0,
				// y: "-100%", // Translate the element by 50% of its height
			}),
			// overflow: "hidden",
			opacity: 0,
			transition: {
				opacity: { duration: 0.15 },
				height: { duration: 0.15 },
				scaleY: { duration: 0.15 },
			},
		},
	};

	return (
		// <motion.div
		<NoSSRMotion
			tag="div"
			variants={variants}
			key={myKey}
			animate={animate}
			initial={initial || animate}
			className={className}
			// transition={{ duration: 5 }}
		>
			<React.Fragment key={myKey}>{children}</React.Fragment>
		</NoSSRMotion>
		// </motion.div>
	);
}
